import { POLISH } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Polish
const PLSection: Section[] = [
  {
    name: '1: Referencje i informacje ogólne',
    subSections: [
      {
        name: 'Wstęp',
        page: 3,
      },
      {
        name: 'Cel i zastosowania przewodnika',
        page: 4,
      },
      {
        name: 'Najważniejsze definicje',
        page: 5,
      },
      {
        name: 'Hierarchia elementów kontrolnych',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Pojazdy silnikowe — bezpieczeństwo ruchu drogowego',
        page: 9,
      },
      {
        name: 'Praca na wysokośc',
        page: 12,
      },
      {
        name: 'Ruchome urządzenie silnikowe',
        page: 18,
      },
      {
        name: 'Blokowanie i oznaczanie / Izolacja dopływu energii',
        page: 22,
      },
      {
        name: 'Prace elektryczne',
        page: 25,
      },
      {
        name: 'Zamknięta przestrzeń',
        page: 29,
      },
      {
        name: 'Przechowywanie materiałów sypkich',
        page: 32,
      },
      {
        name: 'Bezpieczeństwo na kolei',
        page: 37,
      },
      {
        name: 'Prace w wykopach',
        page: 41,
      },
      {
        name: 'Podnoszenie i przenoszenie',
        page: 46,
      },
      {
        name: 'Materiały niebezpieczne',
        page: 49,
      },
      {
        name: 'Prace pożarowo niebezpieczne',
        page: 52,
      },
    ],
  },
  {
    name: '3: Dodatkowe zasoby i narzędzia',
    subSections: [
      {
        name: 'Praca nad wodą i w jej pobliżu',
        page: 56,
      },
      {
        name: 'Upuszczone lub spadające przedmioty',
        page: 59,
      },
      {
        name: 'Testy atmosferyczne/gazu',
        page: 61,
      },
      {
        name: 'Komunikacja dotycząca zagrożeń chemicznych',
        page: 65,
      },
    ],
  },
  {
    name: '4: Zasady zarządzania bezpieczeństwem w firmie Cargill',
    subSections: [
      {
        name: 'Kluczowa terminologia',
        page: 70,
      },
      {
        name: 'Określanie wypadków ciężkich i śmiertelnych (SIF)',
        page: 72,
      },
      {
        name: 'Klasyfikacja potencjalnych wypadków ciężkich i śmiertelnych (SIFp)',
        page: 73,
      },
      {
        name: 'Tabela kryteriów do automatycznego określania SIF',
        page: 74,
      },
      {
        name: 'Wyniki ludzi i organizacji (HOP)',
        page: 76,
      },
    ],
  },
];
const EPLTableofContent: TableOfContent = {
  language: 'pl',
  sections: PLSection,
  label: 'Spis treści',
  pdfLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide POLISH_(pl_PL)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Przewodnik kieszonkowy HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Polish.pdf',
  source: POLISH,
};

export default EPLTableofContent;
